import { message } from 'ant-design-vue'
import { nextTick, reactive, ref } from 'vue'
import { getModelFolderTree, getModelsByFolderId } from '/@/api/model'
import { viewer } from './use-cesium-map'
import * as Cesium from 'cesium'
import { CURRENT_CONFIG } from '/@/api/http/config'
import auth from '/@/plugins/auth'

export const showModelList = ref(false)
export const folderModelsMap = ref({})
export const expandedTreeNodes = reactive<{[x:string|number]:any}>({})
export const treeData = ref([])
export const keepModelList = ref(false)
export const modelTreeData = ref<any[]>([])
export const currentModelTypeKey = ref('')
export const currentModelType = ref(null)
export const modelList = ref({})
export const currentModelKey = ref('')
export const currentModelIndex = ref(0)
export const getTotalModelCount = () => {
  let count = 0

  const countModelTypes = (node) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => countModelTypes(child))
    }

    // 如果是模型类型节点（包含-model3d、-model、-orthophoto、-pointCloud的节点）
    if (node.key && (
    // node.key.includes('-model3d') ||
      node.key.includes('-model') ||
      //  node.key.includes('-orthophoto') ||
                     node.key.includes('-pointCloud'))) {
      count++
    }
  }

  modelTreeData.value.forEach(workspace => {
    countModelTypes(workspace)
  })

  return count
}
// 计算文件夹下的模型数量
export const countFolderModels = (folder) => {
  let count = 0

  const countTypes = (node) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => countTypes(child))
    }

    if (node.key && (
    // node.key.includes('-model3d') ||
      node.key.includes('-model') ||
      //  node.key.includes('-orthophoto') ||
                     node.key.includes('-pointCloud'))) {
      count++
    }
  }

  countTypes(folder)
  return count
}
// 计算工作空间下的模型数量
export const countWorkspaceModels = (workspace) => {
  let count = 0

  const countTypes = (node) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => countTypes(child))
    }

    if (node.key && (
    // node.key.includes('-model3d') ||
      node.key.includes('-model') ||
      //  node.key.includes('-orthophoto') ||
                     node.key.includes('-pointCloud'))) {
      count++
    }
  }

  countTypes(workspace)
  return count
}
export const countModelTypes = (model) => {
  if (!model.children) return 0
  return model.children.filter(child =>
    child.key && (
    // child.key.includes('-model3d') ||
      child.key.includes('-model') ||
      //   child.key.includes('-orthophoto') ||
                  child.key.includes('-pointCloud'))
  ).length
}
// 计算子文件夹下的模型数量
export const countSubFolderModels = (subFolder) => {
  let count = 0

  const countTypes = (node) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => countTypes(child))
    }

    if (node.key && (
    // node.key.includes('-model3d') ||
      node.key.includes('-model') ||
      //  node.key.includes('-orthophoto') ||
                     node.key.includes('-pointCloud'))) {
      count++
    }
  }

  countTypes(subFolder)
  return count
}
// 检查模型类型是否被选中
export const isModelTypeActive = (modelTypeKey) => {
  return currentModelTypeKey.value === modelTypeKey
}

// 切换树节点展开/收起
export const toggleTreeNode = (nodeKey) => {
  expandedTreeNodes[nodeKey] = !expandedTreeNodes[nodeKey]
}

// 获取模型类型描述
export const getModelTypeDesc = (type) => {
  const typeMap = {
    // model3d: '3D模型',
    model: '实景模型',
    // orthophoto: '正射影像',
    pointCloud: '点云数据'
  }
  return typeMap[type] || type
}
const setPointCloud = (url, pointCloudFlag) => {
  nextTick(() => {
    setCustomTiles(url, pointCloudFlag)
  })
}
export const clearCustom = () => {
// 先取消所有事件监听
  const primitives = viewer.scene.primitives
  const length = primitives.length

  // 方法1：从后往前移除所有primitive
  for (let i = length - 1; i >= 0; i--) {
    const primitive = primitives.get(i)
    console.log(primitive, 'primitive')

    // 如果是Cesium3DTileset，先销毁
    if (primitive && (primitive.typeinfo === 'modelTileset' || primitive.typeinfo === 'pointCloud')) {
      try {
        primitives.remove(primitive)
      } catch (e) {
        console.warn('销毁primitive失败:', e)
      }
    }
  }
  viewer.scene.requestRender()
}
const optimizeFor3DBuildings = () => {
  if (!viewer) return

  try {
    // 1. 调整渲染设置
    viewer.scene.globe.maximumScreenSpaceError = 2
    viewer.scene.globe.depthTestAgainstTerrain = true

    // 2. 禁用深度测试以确保模型始终可见
    viewer.scene.globe.depthTestAgainstTerrain = false

    // 3. 调整LOD（细节层次）
    viewer.scene.globe.baseMaximumScreenSpaceError = 1
    viewer.scene.globe.tileCacheSize = 200

    // 4. 启用抗锯齿
    viewer.scene.postProcessStages.fxaa.enabled = true

    // 5. 设置相机约束
    viewer.scene.screenSpaceCameraController.maximumZoomDistance = 5000
    viewer.scene.screenSpaceCameraController.minimumZoomDistance = 2

    // 6. 调整近平面距离以避免模型裁剪
    viewer.scene.camera.minimumDistance = 1.0
    viewer.scene.camera.maximumDistance = 50000000

    // 7. 调整地形设置
    viewer.scene.globe.depthTestAgainstTerrain = false

    // 8. 强制重新渲染
    viewer.scene.requestRender()

    console.log('3D建筑模式优化已应用')
  } catch (error) {
    console.warn('应用3D建筑优化设置失败:', error)
  }
}
/**
 * 加载3D建筑模型和点云数据
 * @param baseUrl 3D Tiles数据源URL
 * @param options 配置选项
 */
export const loadCustom3DTiles = async (
  baseUrl: string,
  options: {
    position?: { lng: number; lat: number; height?: number };
    scale?: number;
    maximumScreenSpaceError?: number;
    show?: boolean;
    token?: string;
    skipTransform?: boolean;
    loadModel?: boolean; // 新增：是否加载模型数据
    loadPointCloud?: boolean; // 新增：是否加载点云数据
  } = {}
) => {
  // 先检查 Cesium 是否可用
  if (typeof Cesium === 'undefined') {
    console.error('Cesium未定义，请确保已正确引入Cesium库')
    throw new Error('Cesium未正确初始化，请检查引入方式')
  }

  if (!viewer) {
    console.error('Cesium Viewer未初始化')
    throw new Error('Cesium Viewer未初始化')
  }

  // 检查必要的Cesium对象是否存在
  if (!Cesium.Cesium3DTileset) {
    console.error('Cesium.Cesium3DTileset未定义')
    throw new Error('Cesium对象未正确初始化，请检查Cesium版本')
  }

  const defaultOptions = {
    position: { lng: 113.453275, lat: 23.185216, height: 0 },
    scale: 1.0,
    maximumScreenSpaceError: 2, // 降低这个值以提高渲染质量
    show: true,
    token: undefined,
    skipTransform: false,
    loadModel: true, // 默认加载模型
    loadPointCloud: true, // 默认加载点云
    ...options
  }

  try {
    console.log('开始加载3D Tiles数据...', baseUrl)
    const url = CURRENT_CONFIG.baseURL.indexOf('192.') === -1 ? CURRENT_CONFIG.baseURL : 'https://www.zstkj.top'
    // 准备请求头
    const headers: Record<string, string> = {}
    if (defaultOptions.token) {
      headers.Authorization = `Bearer ${defaultOptions.token}`
    }

    const tilesets: Cesium.Cesium3DTileset[] = []
    const destroyFunctions: (() => void)[] = []

    // 辅助函数：等待tileset加载
    const waitForTilesetToLoad = (tileset: Cesium.Cesium3DTileset, name: string): Promise<void> => {
      return new Promise<void>((resolve, reject) => {
        let loadedTiles = 0
        let failedTiles = 0
        let hasResolved = false

        // 监听tile加载失败事件
        const tileFailedHandler = (error: any) => {
          console.warn(`${name} tile加载失败:`, error)
          failedTiles++
        }

        // 监听tile加载事件
        const tileLoadHandler = () => {
          loadedTiles++
        }

        // 监听所有tile加载完成事件
        const allTilesLoadedHandler = () => {
          if (!hasResolved) {
            hasResolved = true
            console.log(`${name} 加载完成，已加载${loadedTiles}个tiles，失败${failedTiles}个`)

            // 清理事件监听器
            tileset.tileFailed.removeEventListener(tileFailedHandler)
            tileset.tileLoad.removeEventListener(tileLoadHandler)
            tileset.allTilesLoaded.removeEventListener(allTilesLoadedHandler)

            clearTimeout(timeoutId)
            resolve()
          }
        }

        // 设置超时
        const timeoutId = setTimeout(() => {
          if (!hasResolved) {
            hasResolved = true
            console.warn(`${name} 加载超时，已加载${loadedTiles}个tiles`)

            // 清理事件监听器
            tileset.tileFailed.removeEventListener(tileFailedHandler)
            tileset.tileLoad.removeEventListener(tileLoadHandler)
            tileset.allTilesLoaded.removeEventListener(allTilesLoadedHandler)

            resolve() // 超时也resolve，不reject
          }
        }, 60000) // 60秒超时

        // 添加事件监听器
        tileset.tileFailed.addEventListener(tileFailedHandler)
        tileset.tileLoad.addEventListener(tileLoadHandler)
        tileset.allTilesLoaded.addEventListener(allTilesLoadedHandler)

        // 如果已经加载完成，立即resolve
        if (tileset.allTilesLoaded.raiseEvent) {
          hasResolved = true
          clearTimeout(timeoutId)
          resolve()
        }
      })
    }

    // 1. 加载3D模型数据（如果启用）
    if (defaultOptions.loadModel) {
      try {
        const modelUrl = `${url}${baseUrl}`
        console.log('加载3D模型数据:', modelUrl)

        const modelTileset = await Cesium.Cesium3DTileset.fromUrl(modelUrl, {
          maximumScreenSpaceError: defaultOptions.maximumScreenSpaceError,
          show: defaultOptions.show,
          maximumMemoryUsage: 2048, // 增加内存限制
          cullWithChildrenBounds: false, // 修改这个设置
          skipLevelOfDetail: false, // 修改这个设置
          baseScreenSpaceError: 1024,
          skipScreenSpaceErrorFactor: 4, // 降低这个值
          dynamicScreenSpaceError: true,
          dynamicScreenSpaceErrorDensity: 0.00278,
          dynamicScreenSpaceErrorFactor: 4.0,
          preferLeaves: false, // 添加这个设置
          ...(Object.keys(headers).length > 0 ? { headers } : {})
        })

        // 添加性能优化设置
        modelTileset.dynamicScreenSpaceError = true
        modelTileset.dynamicScreenSpaceErrorDensity = 0.00278
        modelTileset.dynamicScreenSpaceErrorFactor = 4.0
        modelTileset.typeinfo = 'modelTileset'

        // 禁用深度测试以解决模型闪烁问题
        modelTileset.disableDepthTestDistance = Number.POSITIVE_INFINITY

        viewer.scene.primitives.add(modelTileset)
        tilesets.push(modelTileset)

        // 等待模型加载
        await waitForTilesetToLoad(modelTileset, '3D模型数据')

        console.log('3D模型数据加载完成')
      } catch (modelError) {
        console.error('加载3D模型数据失败:', modelError)
        // 不抛出错误，继续尝试加载点云数据
      }
    }

    // 2. 加载点云数据（如果启用）
    if (defaultOptions.loadPointCloud) {
      try {
        const pointCloudUrl = `${url}${baseUrl}`
        console.log('加载点云数据:', pointCloudUrl)

        const pointCloudTileset = await Cesium.Cesium3DTileset.fromUrl(pointCloudUrl, {
          maximumScreenSpaceError: defaultOptions.maximumScreenSpaceError,
          show: defaultOptions.show,
          maximumMemoryUsage: 2048, // 增加内存限制
          cullWithChildrenBounds: false,
          skipLevelOfDetail: false,
          baseScreenSpaceError: 1024,
          skipScreenSpaceErrorFactor: 4,
          dynamicScreenSpaceError: true,
          dynamicScreenSpaceErrorDensity: 0.00278,
          dynamicScreenSpaceErrorFactor: 4.0,
          preferLeaves: false,
          ...(Object.keys(headers).length > 0 ? { headers } : {})
        })

        // 添加性能优化设置
        pointCloudTileset.dynamicScreenSpaceError = true
        pointCloudTileset.dynamicScreenSpaceErrorDensity = 0.00278
        pointCloudTileset.dynamicScreenSpaceErrorFactor = 4.0
        pointCloudTileset.typeinfo = 'pointCloud'
        viewer.scene.primitives.add(pointCloudTileset)
        tilesets.push(pointCloudTileset)

        // 等待点云加载
        await waitForTilesetToLoad(pointCloudTileset, '点云数据')

        console.log('点云数据加载完成')
      } catch (pointCloudError) {
        console.error('加载点云数据失败:', pointCloudError)
        // 不抛出错误，继续执行
      }
    }

    // 3. 检查是否至少有一个tileset加载成功
    if (tilesets.length === 0) {
      console.warn('没有加载任何tileset，请检查配置并重试')
      return
    }

    // 4. 应用位置和缩放变换（如果需要）
    if (!defaultOptions.skipTransform && defaultOptions.position) {
      const { lng, lat, height = 0 } = defaultOptions.position
      const position = Cesium.Cartesian3.fromDegrees(lng, lat, height)
      const transform = Cesium.Transforms.eastNorthUpToFixedFrame(position)

      const scaleMatrix = Cesium.Matrix4.fromScale(
        new Cesium.Cartesian3(
          defaultOptions.scale,
          defaultOptions.scale,
          defaultOptions.scale
        )
      )

      const combinedMatrix = Cesium.Matrix4.multiply(
        transform,
        scaleMatrix,
        new Cesium.Matrix4()
      )

      // 为所有tileset应用相同的变换
      tilesets.forEach(tileset => {
        tileset.modelMatrix = Cesium.Matrix4.clone(combinedMatrix, tileset.modelMatrix)
      })

      console.log('应用了位置和缩放变换')
    }

    // 5. 调整场景设置以优化3D模型显示
    optimizeFor3DBuildings()

    // 6. 飞到第一个tileset（如果有的话）
    if (tilesets.length > 0) {
      try {
        await viewer.flyTo(tilesets[0], {
          duration: 2,
          offset: new Cesium.HeadingPitchRange(0, -0.5, 0)
        })
        console.log('已飞到模型位置')
      } catch (flyError) {
        console.warn('飞到模型位置失败:', flyError)
        // 如果飞到失败，尝试使用默认视角
        viewer.camera.setView({
          destination: Cesium.Cartesian3.fromDegrees(113.453275, 23.185216, 400000),
          duration: 2
        })
      }
    }

    // 7. 添加一个测试函数来检查模型是否真的在场景中
    const checkModelVisibility = () => {
      if (tilesets.length > 0 && defaultOptions.loadModel) {
        const modelTileset = tilesets[0]
        console.log('模型可见性检查:')
        console.log('- show:', modelTileset.show)
        console.log('- 边界球:', modelTileset.boundingSphere)
        console.log('- 地理错误:', modelTileset.geometricError)

        // 强制重新渲染
        viewer.scene.requestRender()
      }
    }

    // 延迟检查模型可见性
    // setTimeout(checkModelVisibility, 2000)

    // 8. 创建销毁函数
    const destroy = () => {
      tilesets.forEach(tileset => {
        if (viewer && viewer.scene && tileset) {
          viewer.scene.primitives.remove(tileset)
        }
      })
      console.log('3D Tiles已移除')
    }

    destroyFunctions.push(destroy)

    return {
      tilesets,
      destroy,
      // 添加一些有用的方法
      getInfo: () => ({
        baseUrl,
        tilesetCount: tilesets.length,
        modelLoaded: defaultOptions.loadModel,
        pointCloudLoaded: defaultOptions.loadPointCloud
      }),
      // 单独控制显示/隐藏
      setVisible: (visible: boolean) => {
        tilesets.forEach(tileset => {
          tileset.show = visible
        })
        viewer.scene.requestRender()
      },
      // 单独控制模型和点云的显示
      setModelVisible: (visible: boolean) => {
        if (tilesets[0]) {
          tilesets[0].show = visible
          viewer.scene.requestRender()
        }
      },
      setPointCloudVisible: (visible: boolean) => {
        if (tilesets[1]) {
          tilesets[1].show = visible
          viewer.scene.requestRender()
        }
      },
      // 刷新渲染
      refresh: () => {
        viewer.scene.requestRender()
      }
    }
  } catch (error) {
    console.error('加载3D Tiles失败:', error)

    // 更详细的错误处理
    if (error instanceof Error) {
      console.error('错误名称:', error.name)
      console.error('错误信息:', error.message)
      console.error('错误堆栈:', error.stack)
    }

    throw new Error(`加载3D数据失败: ${error.message}`)
  }
}
const setCustomTiles = (url, isPointCloud) => {
  clearCustom()
  loadCustom3DTiles(url, {
    skipTransform: true,
    scale: 1.0,
    show: true,
    loadPointCloud: isPointCloud,
    loadModel: !isPointCloud,
    maximumScreenSpaceError: 1,
  })
}

// 清除自定义模型
export const clearModelType = () => {
  currentModelTypeKey.value = ''
  currentModelType.value = null
  currentModelKey.value = ''
  currentModelIndex.value = 0
}
// 选择模型类型
export const selectModelType = (modelTypeNode) => {
  const modelData = modelTypeNode.dataRef
  const type = modelData.type

  // 更新当前选中的模型类型
  currentModelTypeKey.value = modelTypeNode.key
  currentModelType.value = modelData

  // 为了兼容GlbModel组件，构建modelList数据结构
  const categoryName = modelTypeNode.title
  const modelItem = {
    modelName: modelData.modelName,
    type: type,
    fileType: modelData.model3dType,
    modelUrl: modelData[`${type}Url`],
    originalModel: modelData,
    tiles: modelData.tiles || null
  }
  if (type === 'model3d' || type === 'orthophoto') {
  // 构建一个分类，只包含当前选中的模型
    const modelListObj = {}
    modelListObj[categoryName] = [modelItem]

    modelList.value = modelListObj
    currentModelKey.value = categoryName
    currentModelIndex.value = 0
  } else {
    setPointCloud(modelItem.modelUrl, type === 'pointCloud')
  }
  // 选择后隐藏列表
  hideModelList()
}

// 鼠标离开处理
export const handleMouseLeave = () => {
  setTimeout(() => {
    if (!keepModelList.value) {
      showModelList.value = false
    }
  }, 200)
}

export const hideModelList = () => {
  keepModelList.value = false
  showModelList.value = false
}
export const fetchModelList = async (folderId) => {
  try {
    if (folderModelsMap.value[folderId]) {
      return
    }

    const res = await getModelsByFolderId(folderId)
    // console.log('resfolderId', res.data)
    const list = res.data.filter((subFolder: any) => subFolder.pointCloudUrl || subFolder.modelUrl)

    if (list && Array.isArray(list)) {
      folderModelsMap.value[folderId] = list
    } else {
      folderModelsMap.value[folderId] = []
    }
  } catch (error) {
    folderModelsMap.value[folderId] = []
  }
}
export const buildModelTreeData = () => {
  if (treeData.value.length === 0) {
    modelTreeData.value = []
    return
  }

  const treeNodes = treeData.value.map((workspace: any) => {
    const workspaceNode = {
      title: workspace.workspaceName,
      key: `workspace-${workspace.workspaceId}`,
      selectable: false,
      children: []
    }

    workspace.children && workspace.children.forEach((topLevelFolder: any) => {
      const topLevelFolderKey = `folder-${workspace.workspaceId}-${topLevelFolder.id}`
      const topLevelFolderNode = {
        title: topLevelFolder.folderName || topLevelFolder.name || topLevelFolder.title,
        key: topLevelFolderKey,
        dataRef: topLevelFolder,
        children: [],
        selectable: false
      }

      if (topLevelFolder.children && topLevelFolder.children.length > 0) {
        topLevelFolder.children.forEach((subFolder: any) => {
          const subFolderKey = `subfolder-${workspace.workspaceId}-${topLevelFolder.id}-${subFolder.id}`
          const subFolderNode = {
            title: subFolder.folderName || subFolder.name || subFolder.title,
            key: subFolderKey,
            dataRef: subFolder,
            children: [],
            selectable: false
          }

          if (folderModelsMap.value[subFolder.id] && folderModelsMap.value[subFolder.id].length > 0) {
            folderModelsMap.value[subFolder.id].forEach(model => {
              const modelParentKey = `model-${subFolder.id}-${model.id}`
              const modelParentNode = {
                title: model.modelName,
                key: modelParentKey,
                isLeaf: false,
                dataRef: {
                  ...model,
                  folderId: subFolder.id
                },
                children: [],
                selectable: false
              }

              // 根据模型拥有的URL类型创建子节点
              const modelTypeOptions = [
                // { key: 'model3dUrl', label: '3D实体模型', type: 'model3d' },
                { key: 'modelUrl', label: '实景模型', type: 'model' },
                // { key: 'orthophotoUrl', label: '正射影像', type: 'orthophoto' },
                { key: 'pointCloudUrl', label: '点云模型', type: 'pointCloud' }
              ]

              modelTypeOptions.forEach(({ key, label, type }) => {
                if (model[key]) {
                  const modelTypeKey = `${modelParentKey}-${type}`
                  modelParentNode.children.push({
                    title: label,
                    key: modelTypeKey,
                    isLeaf: true,
                    selectable: true,
                    dataRef: {
                      ...model,
                      folderId: subFolder.id,
                      type
                    }
                  })
                }
              })

              if (modelParentNode.children.length === 0) {
                modelParentNode.children.push({
                  title: '暂无可用数据',
                  key: `${modelParentKey}-empty`,
                  isLeaf: true,
                  disabled: true,
                  selectable: false
                })
              }

              subFolderNode.children.push(modelParentNode)
            })
          }

          topLevelFolderNode.children.push(subFolderNode)
        })
      }

      workspaceNode.children.push(topLevelFolderNode)
    })

    return workspaceNode
  })

  modelTreeData.value = treeNodes
}
const getModelFilePage = async (isFirst = false) => {
  try {
    const res = await getModelFolderTree()
    treeData.value = res.data

    if (treeData.value.length === 0) {
      console.warn('暂无模型数据')
      return
    }

    // 获取所有子文件夹
    const allSubFolders: any[] = []

    treeData.value.forEach((workspace: any) => {
      if (workspace.children && workspace.children.length > 0) {
        workspace.children.forEach((topLevelFolder: any) => {
          if (topLevelFolder.children && topLevelFolder.children.length > 0) {
            allSubFolders.push(...topLevelFolder.children)
          }
        })
      }
    })

    // 获取所有文件夹的模型数据
    const modelPromises = allSubFolders.map(subFolder =>
      fetchModelList(subFolder.id)
    )

    await Promise.all(modelPromises)

    // 构建树形结构数据
    buildModelTreeData()

    // 默认展开第一个工作空间
    if (modelTreeData.value.length > 0) {
      expandedTreeNodes[modelTreeData.value[0].key] = true
    }
  } catch (error) {
    console.error('加载模型列表失败:', error)
    message.error('加载模型列表失败')
  }
}
export const loadModelList = async (flag) => {
  if (!auth.hasPermi(['wayline:draw'])) return
  await getModelFilePage(flag)
}

export const showModelChange = () => {
  showModelList.value = true
  loadModelList(false)
}
